import { TYPES } from "./default_paper.type";
import { onSnapshot, query, limit, orderBy, where } from "firebase/firestore";
//func
import { getRefs } from "../ref";
import { getAuth } from "firebase/auth";
import { getDownloadURL, getStorage, ref } from "firebase/storage";
import { getApp } from "firebase/app";
import { getApiFunctions } from "store/bailiff/api";

const app = getApp();
const auth = getAuth(app);
const storage = getStorage(app);
// ========= firebase function =========//

//snap all provider
const allDefaultPaperSub = [];
export const snapDefaultPaper =
  ({ status }, callback) =>
  (dispatch) => {
    setDefaultPaperAllSuccess(dispatch, null);
    const cRef = getRefs().paper;
    const c0 = orderBy("createAt", "desc");
    const c1 = limit(1000);
    const c2 = where("status", "==", status);
    let qRef = query(cRef, c0, c1);
    if (status !== "all") {
      qRef = query(cRef, c0, c1, c2);
    }

    const unsub = onSnapshot(qRef, (snapshot) => {
      if (snapshot) {
        const data = snapshot.docs.map((doc) => doc.data());
        setDefaultPaperAllSuccess(dispatch, data);
        if (callback) {
          callback();
        }
      }
    });
    allDefaultPaperSub.push(unsub);
  };

export const unSnapDefaultPaper = () => (dispatch) => {
  allDefaultPaperSub.forEach((subscriber) => {
    subscriber();
  });
  allDefaultPaperSub.length = 0;
};
// ========= cloud function =========//
export const approveKycByClient =
  ({ client }, callback) =>
  (dispatch) => {
    const functions = getApiFunctions().kyc.verifyKyc;
    const options = { client };
    return functions(options)
      .then(() => {
        callback && callback({ status: 200 });
      })
      .catch((err) => {
        console.log({ err });
        callback &&
          callback({
            status: 500,
            data: "Đã xảy ra lỗi trong quá trình xác nhận kyc, vui lòng thử lại sau",
          });
      });
  };

export const denyKycByClient =
  ({ client, reason }, callback) =>
  (dispatch) => {
    const functions = getApiFunctions().kyc.denyKyc;
    const options = { client, reason };
    return functions(options)
      .then(() => {
        callback && callback({ status: 200 });
      })
      .catch((err) => {
        console.log({ err });
        callback &&
          callback({
            status: 500,
            data: "Đã xảy ra lỗi trong quá trình từ chối đơn kyc, vui lòng thử lại sau",
          });
      });
  };

// ========= storage function =========//
export const getPaperById =
  ({ fileName, client }, callback) =>
  (dispatch) => {
    const path = `paper/kyc/${client}/${fileName}`;

    const storageRef = ref(storage, path);
    getDownloadURL(storageRef)
      .then((url) => {
        callback && callback(url);
      })
      .catch((error) => {
        console.log(error);
        callback && callback(null);
      });
  };
// ========= local function =========//
export const setDefaultPaperAll = (data, callback) => (dispatch) => {
  setDefaultPaperAllSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDefaultPaperOpenAdd = (data, callback) => (dispatch) => {
  setDefaultPaperOpenAddSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDefaultPaperOpenEdit = (data, callback) => (dispatch) => {
  setDefaultPaperOpenEditSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDefaultPaperSelected = (data, callback) => (dispatch) => {
  setDefaultPaperSelectedSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDefaultPaperSearch = (data, callback) => (dispatch) => {
  setDefaultPaperSearchSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

// ========= dispatch =========//

const setDefaultPaperAllSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DEFAULT_PAPER_ALL,
    payload: data,
  });
};

const setDefaultPaperOpenAddSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DEFAULT_PAPER_OPEN_ADD,
    payload: data,
  });
};

const setDefaultPaperOpenEditSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DEFAULT_PAPER_OPEN_EDIT,
    payload: data,
  });
};

const setDefaultPaperSelectedSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DEFAULT_PAPER_SELECTED,
    payload: data,
  });
};

const setDefaultPaperSearchSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DEFAULT_PAPER_SEARCH,
    payload: data,
  });
};
